import React, { Component, useEffect, useState } from "react";
import Search from "../../Components/Users/Search";
import List from "../../Components/Users/List";
import {
  Container,
  ListWrapper,
  SearchWrapper,
} from "../../Components/ContainerSoftware/ContainerElements";
import ModalAdd from "../../Components/Users/Modals/Add";
import ModalSelectRole from "../../Components/Users/Modals/SelectRole";
import ModalOperations from "../../Components/Users/Modals/Operations";
import ModalDelete from "../../Components/Users/Modals/Delete";
import ModalUpdate from "../../Components/Users/Modals/Update";
import ModalUpdateSelectRole from "../../Components/Users/Modals/UpdateSelectRole";

import axiosConfig from "../../ApiCall/axiosConfig";
import { ToastContainer, toast } from "react-toastify";
import { Slide } from "react-toastify";

const Users = () => {
  const [items, setItems] = useState([]);
  const [detailItem, setDetailItem] = useState([]);

  const [role, setRole] = useState();
  const [searchItems, setSearchItems] = useState([]);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalSelectRole, setShowModalSelectRole] = useState(false);
  const [showModalOperations, setShowModalOperations] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showModalUpdateSelectRole, setShowModalUpdateSelectRole] =
    useState(false);

  const [loading, setLoading] = useState(false);
  const handleOpenModal = (modal, role, detailItem) => {
    if (modal === "addModal") {
      setRole(role);
      setShowModalAdd(true);
    } else if (modal === "modalSelectRole") {
      setShowModalSelectRole(true);
    } else if (modal === "modalOperations") {
      setShowModalOperations(true);
      setDetailItem(detailItem);
    } else if (modal === "modalDelete") {
      setShowModalDelete(true);
    } else if (modal === "modalUpdate") {
      setRole(role);
      setShowModalUpdate(true);
    } else if (modal === "modalUpdateSelectRole") {
      setShowModalUpdateSelectRole(true);
    }
  };
  const handleCloseModal = (modal, role) => {
    if (modal === "addModal") {
      setShowModalAdd(false);
    } else if (modal === "closeAddModal") {
      setShowModalAdd(false);
      setRole();
    } else if (modal === "modalSelectRole") {
      setShowModalSelectRole(false);
      setRole(role);
    } else if (modal === "modalOperations") {
      setShowModalOperations(false);
    } else if (modal === "modalDelete") {
      setShowModalDelete(false);
    } else if (modal === "modalUpdate") {
      setShowModalUpdate(false);
    } else if (modal === "modalUpdateSelectRole") {
      setShowModalUpdateSelectRole(false);
    }
  };
  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_user/list/" + companyId,
          config
        );
        const itemsData = data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching users:", error);
      }
    }

    fetchData();
  }, []);
  const handleAddNew = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_user/list/" + companyId,
          config
        );
        const itemsData = data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
      toast.update(toastId, {
        render: "کاربر با موفقیت ثبت شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };
  const handleUpdate = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_user/list/" + companyId,
          config
        );
        const itemsData = data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
      toast.update(toastId, {
        render: "کاربر با موفقیت ثبت شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };
  const handleDelete = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_user/list/" + companyId,
          config
        );
        const itemsData = data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
      toast.update(toastId, {
        render: "کاربر با موفقیت ثبت شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };
  const handleChoose = (role) => {
    setRole(role);
  };
  const filter = (e) => {
    const keyword = e.target.value;
    if (keyword !== "") {
      let results = searchItems.filter((item) => {
        let nameFamily = item?.name + " " + item?.family;
        return (
          nameFamily.toLowerCase().startsWith(keyword.toLowerCase()) ||
          item?.name.toLowerCase().startsWith(keyword.toLowerCase()) ||
          item?.family.toLowerCase().startsWith(keyword.toLowerCase())
        );
      });
      setItems(results);
    } else {
      setItems(searchItems);
    }
  };

  return (
    <>
      <ToastContainer
        transition={Slide}
        className="toast-position"
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Container>
        <SearchWrapper>
          <Search filter={filter} />
        </SearchWrapper>
        <ListWrapper>
          {loading ? (
            <div className="loadingList">
              <div className="spinner"></div>
            </div>
          ) : (
            <List handleOpenModal={handleOpenModal} data={items} />
          )}
        </ListWrapper>
        <ModalAdd
          showAddModal={showModalAdd}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
          handleAddNew={handleAddNew}
          role={role}
        ></ModalAdd>
        <ModalSelectRole
          showModalSelectRole={showModalSelectRole}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
          handleChoose={handleChoose}
          defaultRole={role}
        ></ModalSelectRole>
        <ModalOperations
          showModalOperations={showModalOperations}
          detailItem={detailItem}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
        ></ModalOperations>
        <ModalDelete
          showModalDelete={showModalDelete}
          detailItem={detailItem}
          handleCloseModal={handleCloseModal}
          handleDelete={handleDelete}
        ></ModalDelete>
        <ModalUpdate
          detailItem={detailItem}
          showModalUpdate={showModalUpdate}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
          handleUpdate={handleUpdate}
          role={role}
        ></ModalUpdate>
        <ModalUpdateSelectRole
          showModalSelectRole={showModalUpdateSelectRole}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
          handleChoose={handleChoose}
          defaultRole={role}
          detailItem={detailItem}
        ></ModalUpdateSelectRole>
      </Container>
    </>
  );
};

export default Users;
